export default __webpack_public_path__ + "static/media/denis-guendes-amanase.3af3d234.png";